import { useState, useRef, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import Loader from "../../components/loader";
import UiButton from "../../components/button";
import TextInput from "../../components/textinput/TextInput";
import {
  useSupportedTokens,
  useNetworkOptions,
  useCustodianData,
} from "../../context/contractDataLoaderService";

import ERC20ABI from "../../utils/abi/ERC20.json";
import PaymentModal from "../../pages/custodian/Payments/PaymentModal";
import paymentGateway from "../../pages/custodian/api/PaymentGateway";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Web3 from "web3";
import {
  ERC20,
  PrimaryIssueManager,
  SecuritiesFactory,
  contractAddress,
} from "@verified-network/verified-sdk";
import {
  SuccessToast,
  FailureToast,
  ToastOptions,
  networks,
} from "../../utils/constants";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../utils/helpers/networks";
import { ethers, providers } from "ethers";
import { useGlobal } from "../../context/globalContext";
import { getAllVerifiedCashBalances } from "../../utils/helpers";

function NewOffer(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [issueAmount, setIssueAmount] = useState("");
  const [desiredAmount, setDesiredAmount] = useState("");
  const [minInvestment, setMinInvestment] = useState("");
  const [ipfsDoc, setIpfsDoc] = useState("");
  let { data: tokensSupported } = useSupportedTokens();
  const [changeContent, setChangeContent] = useState(false);
  const [paymentModalVisibility, setPaymentModalVisibility] = useState(false);
  const [paymentResponse, setPaymentResponse] = useState(null);
  const { data: networkOptions } = useNetworkOptions();
  const history = useHistory();
  let { data: custodianData } = useCustodianData(
    null,
    props.data.offered,
    props.data.owner,
  );

  const tokenSelected = tokensSupported?.find(
    (data) => data.tokenAddress === props.data.currencyAddress,
  );

  const modalContent = useRef(null);

  let primaryIssueManagerContract, factoryContract;
  if (provider && provider.getSigner && chainId && address) {
    const BalancerPrimaryIssueManager =
      contractAddress[chainId].BalancerPrimaryIssueManager;
    if (BalancerPrimaryIssueManager) {
      primaryIssueManagerContract = new PrimaryIssueManager(
        signer,
        BalancerPrimaryIssueManager,
        "balancer",
      );
    }
    if (contractAddress[chainId].SecuritiesFactory) {
      factoryContract = new SecuritiesFactory(
        signer,
        contractAddress[chainId].SecuritiesFactory,
      );
    }
  }

  const clearQueryParams = () => {
    history.push({
      search: "",
    });
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const redirectStatus = searchParams.get("redirect_status");

    switch (redirectStatus) {
      case "succeeded":
        toast.success(SuccessToast("", "Payment Successful!"), ToastOptions);
        clearQueryParams();
        break;
      case "failed":
        toast.error(FailureToast("", "Payment Unsuccessful!"), ToastOptions);
        clearQueryParams();
        break;
      default:
        break;
    }
  }, []);

  const stripePayment = async () => {
    const selectedFiatCurrency = custodianData?.find(
      (data) => data.issueCurrencyAddress === props.data.currencyAddress,
    );

    // Code for creating cash request for Fiat Payment
    try {
      setLoading(true);
      await paymentGateway
        .createCashIssueRequest(
          selectedFiatCurrency.country,
          account,
          selectedFiatCurrency.accountId,
          issueAmount,
          selectedFiatCurrency.currency,
          selectedFiatCurrency.issueCurrencyAddress,
          chainId,
        )
        .then((result) => {
          console.log("Result after API createCashIssueRequest", result);
          setLoading(false);
          setPaymentModalVisibility(true);
          setPaymentResponse(result);
        });
    } catch (error) {
      setLoading(false);
      toast.error(
        FailureToast("", "Amount must be at least CHF 0.50 chf"),
        ToastOptions,
      );
      console.log("Error", error);
    }
  };

  const offerCurrency = async () => {
    const rowData = props.data;
    if (issueAmount.length == 0) {
      alert("Enter issue amount");
    } else if (desiredAmount.length == 0) {
      alert("Enter desired amount");
    } else if (minInvestment.length == 0) {
      alert("Enter minimum investment");
    }

    const currencyTokenContract = new web3.eth.Contract(
      ERC20ABI,
      rowData.currencyAddress,
    );

    const currencyTokenContractVer = new ERC20(signer, rowData.currencyAddress);
    const BalancerPrimaryIssueManager =
      contractAddress[chainId].BalancerPrimaryIssueManager;
    const tokenDecimals = await currencyTokenContract.methods.decimals().call();
    const amountOfferedFixed = ethers.utils.parseUnits(
      issueAmount?.toString(),
      Number(tokenDecimals),
    );
    const allowance = currencyTokenContract.methods
      .allowance(account, BalancerPrimaryIssueManager)
      .call();
    setLoading(true);
    let isApproved = false;
    if (Number(allowance) > Number(amountOfferedFixed)) {
      isApproved = true;
    } else {
      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account,
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions,
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await currencyTokenContractVer._getMeeQuote(
          cashTokens[0]?.address,
          "approve",
          [BalancerPrimaryIssueManager, amountOfferedFixed?.toString()],
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions,
          );

          return;
        }
      }

      await currencyTokenContractVer
        .approve(
          BalancerPrimaryIssueManager,
          amountOfferedFixed?.toString(),
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {},
        )
        .then((res) => {
          if (res?.status === 0) {
            isApproved = true;
          } else {
            setLoading(false);
            toast.error("Approve Failed", ToastOptions);
          }
        })
        .catch((err) => {
          console.error("approval function failed with error: ", err);
          setLoading(false);
          toast.error("Approve Failed", ToastOptions);
        });
    }
    if (isApproved) {
      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account,
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions,
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await primaryIssueManagerContract._getMeeQuote(
          cashTokens[0]?.address,
          "offer",
          [
            rowData.currencyAddress,
            rowData.isin,
            amountOfferedFixed?.toString(),
            rowData.offered,
            desiredAmount,
            minInvestment,
            account,
            rowData.offeringDoc,
          ],
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions,
          );

          return;
        }
      }
      try {
        await primaryIssueManagerContract
          .offer(
            rowData.currencyAddress,
            rowData.isin,
            amountOfferedFixed?.toString(),
            rowData.offered,
            desiredAmount,
            minInvestment,
            account,
            rowData.offeringDoc,
            paymentToken?.address
              ? {
                  paymentToken: paymentToken?.address,
                  apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                }
              : {},
          )
          .then((res) => {
            setLoading(false);
            if (res?.status === 0) {
              const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
              toast.success(SuccessToast(transactionLink), ToastOptions);
              setChangeContent(true);
              modalContent.current.innerHTML = "";
            } else {
              toast.error("Transaction Failed!", ToastOptions);
            }
          });
      } catch (err) {
        let error = { err };
        console.log(error);
        const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${error.err?.transactionHash}`;
        setLoading(false);
        toast.error(FailureToast(transactionLink), ToastOptions);
      }
    }
  };
  return (
    <>
      {loading ? <Loader /> : null}
      {changeContent && (
        <UiButton
          onClick={() => {
            props.onModalHide();
          }}
          buttonVariant="primary"
          buttonClass="SignUpButton flex-1 ml-0"
          buttonText="Click to close this form&nbsp;&rarr;"
          type="submit"
        />
      )}
      <div className="d-grid gap-2" ref={modalContent}>
        <Row className="ml-1 align-items-center">
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Offer amount</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Currenncy Amount"
                fieldType="number"
                onChange={(e) => setIssueAmount(e.target.value)}
                required
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Target investment</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Desired Security Amount"
                fieldType="number"
                onChange={(e) =>
                  setDesiredAmount(web3.utils.toWei(e.target.value, "ether"))
                }
                required
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Minimum investment</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Minimum Security Amount"
                fieldType="number"
                onChange={(e) =>
                  setMinInvestment(web3.utils.toWei(e.target.value, "ether"))
                }
                required
              />
            </Col>
          </Row>
        </Row>
        <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
          <Col className="pl-0">
            <UiButton
              onClick={() => {
                if (web3 && signer && chainId && account) {
                  offerCurrency();
                }
              }}
              buttonVariant="primary"
              buttonClass="SignUpButton flex-1 ml-0"
              buttonText="Make Offer"
              type="submit"
            />
          </Col>
        </Row>
        <PaymentModal
          show={paymentModalVisibility}
          paymentRequest={paymentResponse}
          onHide={() => {
            setPaymentModalVisibility(!paymentModalVisibility);
          }}
        />
      </div>
    </>
  );
}

export function MakeOffer(props) {
  return <NewOffer {...props} />;
}
